import { render, staticRenderFns } from "./follow.vue?vue&type=template&id=93697944&scoped=true&"
import script from "./follow.vue?vue&type=script&lang=js&"
export * from "./follow.vue?vue&type=script&lang=js&"
import style0 from "./follow.vue?vue&type=style&index=0&id=93697944&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93697944",
  null
  
)

export default component.exports